import React from 'react';
import styles from "./Content.module.css";
import {cn} from "../../../utils/cn.ts";

const content = [
  {
    title: 'ВСЕГДА НА СВЯЗИ',
    text:
      <div><div>7 дней в неделю</div><div>без перерывов</div></div>,
  },
  {
    title: 'ВСЁ В ОДНОМ МЕСТЕ',
    text:
    <div><div>Более 190 000 автозапчастей</div><div>по ОПТимальной цене</div></div>,
  },
  {
    title: 'ОПЕРАТИВНОСТЬ И ЗАБОТА',
    text:
    <div>СМС-уведомление на каждом этапе заказа</div>,
  },
  {
    title: 'ПРОФЕССИОНАЛИЗМ',
    text:
    <div><div>Персональный менеджер</div><div>подберёт по каталогу</div></div>,
  },
  {
    title: 'ДОСТАВКА',
    text:
    <div><div>по городу от 30 минут</div><div>и по всей России ежедневно</div></div>,
  },
  {
    title: 'ГАРАНТИЯ',
    text: <div>до 3-х лет</div>,
  },
  {
    title: 'ВОЗВРАТ',
    text: <div><div>Бесплатно сделаем</div><div>возврат и вернём деньги</div></div>,
  },
  {
    title: 'БОНУСЫ',
    text: <div><div>за каждую покупку. Оплачивайте следующие</div><div>покупки со скидкой до 10%</div></div>,
  },
];

interface Props {
}

export const About: React.FC<Props> = () => {
  return (
      <div style={{width: '100%', maxWidth: 1270, display: 'flex', flexDirection: 'column', flexBasis: 'inherit',}}>
        <div className={cn(styles.paper, styles.root)}>
          <div className={cn(styles.container,styles.spacingXs40)}>
            <div className={cn(styles.images, styles.gridXs12, styles.gridMd6, styles.gridLg4, styles.item)}>
              <img src="/img/about-2.png"/>
            </div>
            <div className={cn(styles.images, styles.gridXs12, styles.gridMd6, styles.gridLg4, styles.item)}>
              <img src="/img/about-3.png"/>
            </div>
            <div className={cn(styles.images, styles.gridXs12, styles.gridMd6, styles.gridLg4, styles.item)}>
              <img src="/img/about-4.png"/>
            </div>
          </div>
          <div className={cn(styles.container,styles.spacingXs40)}>
          <div className={cn(styles.gridXs12, styles.item)} style={{marginTop: 16,}}>
              <div className={cn(styles.typography,styles.typographyTitle,styles.title)}>О СЕРВИСЕ</div>
              <div className={cn(styles.typography,styles.typographySubheading)}>
                <div>Приветствуем в сервисе ПОДЗАМЕНУ - твоём лучшем друге в мире автотоваров!</div>
                <div style={{marginTop: 16,}}>Мы знаем, как важен для тебя автомобиль и как хочется ему дать только
                  лучшее. Поэтому предлагаем удобный и надёжный сервис, где можно заказать, оплатить, получить и вернуть
                  любые автотовары без лишних хлопот.
                </div>
                <div style={{marginTop: 16,}}>Но не только это отличает нас от других. У нас есть секретное оружие -
                  наши консультанты. Они - настоящие эксперты в области автотоваров и знают все тонкости.
                </div>
                <div>Подберут именно то, что подходит для твоего авто, и помогут сэкономить не только деньги, но и
                  нервы.
                </div>
                <div>Они - такие же автолюбители, как и ты, и понимают все твои потребности и желания.</div>
                <div style={{marginTop: 16,}}>Мы не просто продаём автотовары - мы делимся с тобой своей страстью к
                  автомобилям.
                </div>
              </div>
            </div>
            {content.map(item => (
                <div className={cn(styles.gridXs12,styles.gridMd6,styles.item,styles.row)} key={item.title}>
                  <div className={cn(styles.typography,styles.typographyTitle,styles.title)}>{item.title}</div>
                  <div className={cn(styles.typography,styles.typographySubheading)}>{item.text}</div>
                </div>
            ))}
          </div>
        </div>
      </div>
      );
}
